export type CtaAlignment = "left" | "center" | "right";

const CTA_ALIGNMENT_CLASS: Record<CtaAlignment, string> = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
};

const CTA_GROUP_ALIGNMENT_CLASS: Record<CtaAlignment, string> = {
  left: "items-start justify-start",
  center: "items-center justify-center",
  right: "items-end justify-end",
};

export function getCtaAlignmentClassName(
  align: CtaAlignment = "center",
): string {
  return CTA_ALIGNMENT_CLASS[align];
}

export function getCtaGroupAlignmentClassName(
  align: CtaAlignment = "center",
): string {
  return CTA_GROUP_ALIGNMENT_CLASS[align];
}
